/**
 * Chef Banchan Weekly Deal Manager - V3.18
 * DOM-based + Drawer + Calendar Filter (이번 주/다음 주 월~토)
 * 특가 포함 전체 합산으로 $120 체크
 * 우선순위: event-system > weekly deal
 * CSS 클래스 방식 수량 잠금 (다른 상품 수량 변경 방해 안 함)
 * V3.3: 김치 사전예약 + 1+1 동시 담기 방지
 * V3.4: 무료증정 아이템 감지 시 최소주문금액 $120 → $99.99 변경
 *        무료증정 아이템도 수량 1개 고정
 * V3.5: 무료증정 감지를 SKU → Variant ID 방식으로 변경
 * V3.6: EG 앱 제거 → 스크립트로 무료증정 자동 add/remove
 * V3.15: 무료증정 조건을 "배송일 기준" → "주문 시점 기준"으로 변경
 *        - 현재 시각이 메타필드 기간(start_date 00:00 ~ end_date 23:59) 안이면 증정
 *        - 배송 캘린더 날짜와 무관하게 작동
 *        - 최소주문금액 $100 → $99.99
 *        - 캘린더에 유효 날짜 없을 때 증정 제거하던 로직 삭제 (배송일과 무관해짐)
 * V3.16: 무료증정 조건 기준 토글 추가 (메타필드 freegift.condition_mode)
 *        - 'order'    = 주문 시점 기준 (지금 시각이 기간 내면 증정)
 *        - 'delivery' = 배송일 기준 (기간 내 배송 가능 날짜 있어야 증정, V3.14 방식)
 *        - 미설정 시 기본값: 'order'
 * V3.17: Cart Drawer에서도 무료증정 자동 add/remove 작동
 *        - 드로어 DOM 변화 감지 시 enforceWeeklyDealRules 실행 (디바운스)
 *        - delivery 모드에서 캘린더 없는 페이지면 판단 보류 (잘못된 제거 방지)
 * V3.18: 이벤트 종료 후 무한 새로고침 버그 수정
 *        - FREE_GIFT_SKU / FREE_GIFT_VARIANT_ID가 빈 값('')일 때, SKU 없는 일반 상품과
 *          빈 문자열이 매칭되어 전부 무료증정으로 오인 → 제거 → reload 무한 반복하던 문제 해결
 *        - 설정값이 비어있으면 무료증정 기능 자체를 비활성화
 *        - sessionStorage 리로드 가드: 30초 내 자동 reload 2회 초과 시 중단
 */

(function() {
  console.log('🎯 Weekly Deal Manager V3.18 Start');

  var DEAL_TAG = 'weekly-deal';
  var DEFAULT_MIN_CART_TOTAL = 120.00;
  var FREE_GIFT_MIN_CART_TOTAL = 99.99;                 // V3.15: $100 → $99.99
  var MIN_CART_TOTAL = DEFAULT_MIN_CART_TOTAL; // 동적으로 변경됨
  var MAX_DEAL_QUANTITY = 1;
  var KIMCHI_SKUS = ['0DG-0IB-00', '0DH-0IC-00'];
  var FREE_GIFT_SKU = '';                    // [무료증정] 비워두면 무료증정 기능 OFF
  var FREE_GIFT_VARIANT_ID = '';          // [무료증정] 비워두면 무료증정 기능 OFF

  var isProcessing = false;
  var isFreeGiftProcessing = false; // 무료증정 add/remove 처리 중 플래그
  var hasDealInCart = false;
  var hasFreeGiftInCart = false;
  var calendarInitialized = false;
  var lastFreeGiftState = null; // 마지막 무료증정 상태 캐시 (중복 실행 방지)

  // ===================================
  // 🛡️ V3.18: 안전 가드
  // ===================================

  // 무료증정 설정값이 하나라도 있어야 기능 활성
  // (빈 문자열은 매칭에 사용하지 않음 → 이벤트 종료 후 값 비웠을 때 무한 리로드 방지)
  var FREE_GIFT_ENABLED = FREE_GIFT_SKU !== '' || FREE_GIFT_VARIANT_ID !== '';

  // 무료증정 아이템 매칭 (빈 설정값은 절대 매칭되지 않음)
  function isFreeGiftMatch(variantId, sku) {
    var idMatch = FREE_GIFT_VARIANT_ID !== '' && String(variantId) === String(FREE_GIFT_VARIANT_ID);
    var skuMatch = FREE_GIFT_SKU !== '' && sku === FREE_GIFT_SKU;
    return idMatch || skuMatch;
  }

  // 무한 새로고침 방지: 30초 안에 자동 reload 2회까지만 허용
  var RELOAD_GUARD_KEY = 'wdm_reload_guard';
  var RELOAD_LIMIT = 2;
  var RELOAD_WINDOW_MS = 30000;

  function canReloadSafely() {
    try {
      var data = JSON.parse(sessionStorage.getItem(RELOAD_GUARD_KEY) || '{"count":0,"ts":0}');
      var now = Date.now();
      if (now - data.ts > RELOAD_WINDOW_MS) {
        data = { count: 0, ts: now };
      }
      if (data.count >= RELOAD_LIMIT) {
        console.warn('🛑 자동 새로고침 한도 초과 → reload 중단 (무한 리프레시 방지)');
        return false;
      }
      data.count += 1;
      data.ts = now;
      sessionStorage.setItem(RELOAD_GUARD_KEY, JSON.stringify(data));
      return true;
    } catch (e) {
      // sessionStorage 사용 불가 시 reload 자체를 막는 게 안전
      return false;
    }
  }

  // ===================================
  // 📅 배송 날짜 범위 계산
  // ===================================

  function getWeeklyDealDateRange() {
    // V3.15 참고: 무료증정은 더 이상 이 범위를 쓰지 않음 (주문 시점 기준)
    // 이 함수는 weekly-deal 캘린더 필터에만 사용됨
    // 메타필드 값 우선 사용 (window.freeGiftConfig)
    var config = window.freeGiftConfig;
    if (config && config.startDate && config.endDate) {
      var start = new Date(config.startDate + 'T00:00:00');
      var end = new Date(config.endDate + 'T23:59:59');
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      console.log('📅 Weekly Deal 배송 범위 (메타필드):', config.startDate, '~', config.endDate);
      return { start: start, end: end, startStr: config.startDate, endStr: config.endDate };
    }

    // 메타필드 없을 때 fallback: 자동 계산 (이번주/다음주 월~토)
    var now = new Date();
    var currentDay = now.getDay();
    var daysToMonday;
    if (currentDay === 0) {
      daysToMonday = 1;
    } else if (currentDay >= 5) {
      daysToMonday = 8 - currentDay;
    } else {
      daysToMonday = 1 - currentDay;
    }
    var targetMonday = new Date(now);
    targetMonday.setDate(now.getDate() + daysToMonday);
    targetMonday.setHours(0, 0, 0, 0);
    var targetSaturday = new Date(targetMonday);
    targetSaturday.setDate(targetMonday.getDate() + 5);
    targetSaturday.setHours(23, 59, 59, 999);
    var startStr = targetMonday.getFullYear() + '-' +
      String(targetMonday.getMonth() + 1).padStart(2, '0') + '-' +
      String(targetMonday.getDate()).padStart(2, '0');
    var endStr = targetSaturday.getFullYear() + '-' +
      String(targetSaturday.getMonth() + 1).padStart(2, '0') + '-' +
      String(targetSaturday.getDate()).padStart(2, '0');
    console.log('📅 Weekly Deal 배송 범위 (자동):', startStr, '~', endStr);
    return { start: targetMonday, end: targetSaturday, startStr: startStr, endStr: endStr };
  }

  // ===================================
  // 🎯 event-system 이벤트 제품 감지
  // ===================================

  function hasEventSystemProducts() {
    if (window._lastEventDetection && window._lastEventDetection.length > 0) {
      console.log('🎯 Event-system 제품 감지됨 → weekly deal 캘린더 필터 스킵');
      return true;
    }
    return false;
  }

  // ===================================
  // 📅 캘린더 날짜 숨기기만 (클릭 없음)
  // ===================================

  function filterCalendarDatesOnly() {
    var range = getWeeklyDealDateRange();
    var dateOptions = document.querySelectorAll('.date-option');
    if (dateOptions.length === 0) return;

    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      var dateStr = option.dataset.date;
      if (!dateStr) continue;

      var parts = dateStr.split('-');
      var optionDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));

      if (optionDate >= range.start && optionDate <= range.end) {
        option.style.display = '';
      } else {
        option.style.display = 'none';
      }
    }

    updateWeeklyDealSubtitle(range);
  }

  // ===================================
  // 📅 캘린더 필터링 + 첫 날짜 자동 선택
  // ===================================

  function applyWeeklyDealCalendarFilter() {
    if (hasEventSystemProducts()) {
      console.log('⏭️ Event-system 우선 → weekly deal 캘린더 필터 안 함');
      return;
    }

    if (!hasDealInCart) {
      restoreNormalCalendar();
      return;
    }



    var range = getWeeklyDealDateRange();
    var dateOptions = document.querySelectorAll('.date-option');
    if (dateOptions.length === 0) return;

    var visibleCount = 0;
    var hiddenCount = 0;

    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      var dateStr = option.dataset.date;
      if (!dateStr) continue;

      var parts = dateStr.split('-');
      var optionDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));

      if (optionDate >= range.start && optionDate <= range.end) {
        option.style.display = '';
        visibleCount++;
      } else {
        option.style.display = 'none';
        hiddenCount++;
      }
    }

    console.log('📅 Weekly Deal 캘린더 필터: ' + visibleCount + '개 표시, ' + hiddenCount + '개 숨김');

    if (visibleCount === 0) {
      console.log('📅 범위 내 배송 가능 날짜 없음 → 캘린더 복원');
      restoreNormalCalendar();

      // V3.16: delivery 모드일 때만 무료증정 제거 (order 모드는 배송일 무관)
      var cfg = getFreeGiftConfig();
      if (cfg && cfg.mode === 'delivery' && hasFreeGiftInCart && FREE_GIFT_VARIANT_ID !== '') { // V3.18
        var removeUpdate = {};
        removeUpdate[FREE_GIFT_VARIANT_ID] = 0;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removeUpdate })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          showNotification('Free gift is not available for your delivery dates.', 'warning');
          var cartItems = document.getElementById('main-cart-items');
          if (cartItems) {
            cartItems.style.opacity = '0.4';
            cartItems.style.pointerEvents = 'none';
            cartItems.style.transition = 'opacity 0.15s ease';
          }
          if (canReloadSafely()) window.location.reload(); // V3.18: reload 가드
        });
      }
      return;
    }

    selectFirstVisibleDate();
    updateWeeklyDealSubtitle(range);
  }

  function restoreNormalCalendar() {
    var dateOptions = document.querySelectorAll('.date-option');
    var wasFiltered = false;

    for (var i = 0; i < dateOptions.length; i++) {
      if (dateOptions[i].style.display === 'none') wasFiltered = true;
      dateOptions[i].style.display = '';
    }

    if (wasFiltered) {
      var subtitle = document.getElementById('calendar-subtitle');
      if (subtitle) {
        var today = new Date();
        var mn = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var dn = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
        var todayText = '[Today: ' + mn[today.getMonth()] + ' ' + today.getDate() + ' ' + dn[today.getDay()] + ']';

        var fulfillment = document.getElementById('selectedFulfillmentMethod');
        var isPickup = fulfillment && fulfillment.value === 'pickup';
        var msg = isPickup ? 'Please select your pickup date.' : 'Please select your delivery date.';
        subtitle.innerHTML = todayText + ' - ' + msg;
        subtitle.style.color = '#808080';
      }
      console.log('🔄 캘린더 정상 복원');
    }
  }

  function selectFirstVisibleDate() {
    var dateOptions = document.querySelectorAll('.date-option');

    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      if (option.style.display !== 'none') {
        var allOptions = document.querySelectorAll('.date-option');
        for (var j = 0; j < allOptions.length; j++) {
          allOptions[j].classList.remove('selected');
          allOptions[j].style.background = '';
          allOptions[j].style.borderColor = '';
          allOptions[j].style.color = '';
        }

        option.click();
        console.log('📅 첫 번째 날짜 자동 선택:', option.dataset.date);
        break;
      }
    }
  }

  function updateWeeklyDealSubtitle(range) {
    var subtitle = document.getElementById('calendar-subtitle');
    if (!subtitle) return;

    var today = new Date();
    var mn = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var dn = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
    var todayText = '[Today: ' + mn[today.getMonth()] + ' ' + today.getDate() + ' ' + dn[today.getDay()] + ']';

    var startMonth = range.start.getMonth() + 1;
    var startDay = range.start.getDate();
    var endMonth = range.end.getMonth() + 1;
    var endDay = range.end.getDate();

    var rangeMsg = 'Weekly Special delivery: ' + startMonth + '/' + startDay + ' - ' + endMonth + '/' + endDay;

    subtitle.innerHTML = todayText + ' ' + rangeMsg;
    subtitle.style.color = '#FF4713';
  }

  // ===================================
  // 💰 장바구니 분석 (DOM 기반)
  // ===================================

  function analyzeCartFromDOM() {
    var rows = document.querySelectorAll('tr.cart-item[data-tags]');
    var dealItems = [];
    var cartTotal = 0;
    var freeGiftDetected = false;
    var freeGiftVariantId = null;
    var freeGiftQuantity = 0;

    rows.forEach(function(row) {
      var tags = (row.getAttribute('data-tags') || '').split(',');
      var hasDealTag = tags.some(function(tag) {
        return tag.trim() === DEAL_TAG;
      });

      var qtyInput = row.querySelector('.quantity__input');
      if (!qtyInput) return;

      var variantId = qtyInput.getAttribute('data-quantity-variant-id');
      var quantity = parseInt(qtyInput.value, 10) || 1;

      // SKU 감지: data-sku 속성 또는 row의 다른 속성에서 읽기
      var sku = row.getAttribute('data-sku') || row.getAttribute('data-variant-sku') || '';

      // 무료증정 감지: Variant ID 우선, SKU fallback
      if (isFreeGiftMatch(variantId, sku)) { // V3.18: 빈 값 매칭 차단
        freeGiftDetected = true;
        freeGiftVariantId = variantId;
        freeGiftQuantity = quantity;
        console.log('🎁 무료증정 아이템 감지 (DOM):', variantId, 'Qty:', quantity);
      }

      var priceEl = null;
      var allPrices = row.querySelectorAll('.cart-item__totals price-money bdi');
      if (allPrices.length > 0) {
        priceEl = allPrices[allPrices.length - 1];
      }

      var linePrice = 0;
      if (priceEl) {
        var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
        linePrice = parseFloat(priceText) || 0;
      }

      cartTotal += linePrice;

      if (hasDealTag) {
        dealItems.push({
          id: variantId,
          quantity: quantity,
          sku: sku,
          row: row
        });
        console.log('  ✅ Deal item (DOM):', variantId, 'SKU:', sku, 'Qty:', quantity, '$' + linePrice.toFixed(2));
      } else {
        console.log('  📦 Regular item (DOM): $' + linePrice.toFixed(2));
      }
    });

    console.log('  💰 Cart total: $' + cartTotal.toFixed(2));
    console.log('  🎁 Free gift in cart:', freeGiftDetected);

    return {
      dealItems: dealItems,
      cartTotal: cartTotal,
      totalDealQuantity: dealItems.reduce(function(sum, item) {
        return sum + item.quantity;
      }, 0),
      freeGiftDetected: freeGiftDetected,
      freeGiftVariantId: freeGiftVariantId,
      freeGiftQuantity: freeGiftQuantity
    };
  }

  // ===================================
  // 💰 장바구니 분석 (API fallback)
  // ===================================

  function analyzeCartFromAPI() {
    return fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var dealItems = [];
        var cartTotal = cart.total_price / 100;
        var freeGiftDetected = false;
        var freeGiftVariantId = null;
        var freeGiftQuantity = 0;

        // 무료증정 SKU 먼저 체크
        cart.items.forEach(function(item) {
          if (isFreeGiftMatch(item.id, item.sku)) { // V3.18: 빈 값 매칭 차단
            freeGiftDetected = true;
            freeGiftVariantId = item.id;
            freeGiftQuantity = item.quantity;
            console.log('🎁 무료증정 아이템 감지 (API):', item.id, 'Qty:', item.quantity);
          }
        });

        var tagPromises = cart.items.map(function(item) {
          return fetch('/products/' + item.handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(product) {
              var tags = (product.tags || []).map(function(t) { return t.toLowerCase(); });
              return { item: item, hasDealTag: tags.indexOf(DEAL_TAG) !== -1 };
            })
            .catch(function() {
              return { item: item, hasDealTag: false };
            });
        });

        return Promise.all(tagPromises).then(function(results) {
          results.forEach(function(result) {
            if (result.hasDealTag) {
              dealItems.push({
                id: result.item.id,
                quantity: result.item.quantity,
                sku: result.item.sku
              });
            }
          });

          return {
            dealItems: dealItems,
            cartTotal: cartTotal,
            totalDealQuantity: dealItems.reduce(function(sum, item) {
              return sum + item.quantity;
            }, 0),
            freeGiftDetected: freeGiftDetected,
            freeGiftVariantId: freeGiftVariantId,
            freeGiftQuantity: freeGiftQuantity
          };
        });
      });
  }

  // ===================================
  // 🎁 최소주문금액 동적 업데이트
  // ===================================

  function updateMinCartTotal(freeGiftDetected) {
    var previous = MIN_CART_TOTAL;

    if (freeGiftDetected) {
      MIN_CART_TOTAL = FREE_GIFT_MIN_CART_TOTAL; // $99.99
    } else {
      MIN_CART_TOTAL = DEFAULT_MIN_CART_TOTAL;   // $120
    }

    if (previous !== MIN_CART_TOTAL) {
      console.log('🎁 최소주문금액 변경: $' + previous + ' → $' + MIN_CART_TOTAL);
    }
  }

  // ===================================
  // 🔧 규칙 적용
  // ===================================

  function enforceRules(analysis) {
    var previousHasDeal = hasDealInCart;
    hasDealInCart = analysis.dealItems.length > 0;
    hasFreeGiftInCart = analysis.freeGiftDetected;

    // 🎁 1단계: 무료증정 자동 add/remove 먼저 실행
    // reloading=true 이면 페이지 리로드 중 → 나머지 로직 스킵
    return manageFreeGift(analysis).then(function(reloading) {
      if (reloading) return;

      // 무료증정 상태 반영 후 최소주문금액 업데이트
      updateMinCartTotal(hasFreeGiftInCart);

      // ✅ 김치 사전예약 + 1+1 동시 담기 방지
      if (hasDealInCart) {
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var hasKimchi = cart.items.some(function(item) {
              return KIMCHI_SKUS.indexOf(item.sku) !== -1;
            });

            if (hasKimchi) {
              console.log('🚨 김치 + 1+1 동시 감지 → 1+1 제거');
              var removeUpdates = {};
              analysis.dealItems.forEach(function(item) {
                removeUpdates[item.id] = 0;
              });
              showNotification('Pre-order kimchi and 1+1 items cannot be ordered together. The 1+1 item has been removed.', 'warning');
              return updateCart(removeUpdates);
            }

            return applyNormalRules(analysis, previousHasDeal);
          });
      }

      return applyNormalRules(analysis, previousHasDeal);
    });
  }

  // Liquid에서 주입된 메타필드 값 읽기
  // theme.liquid에 아래 스크립트 추가 필요:
  // <script>
  //   window.freeGiftConfig = {
  //     startDate: "{{ shop.metafields.freegift.start_date.value }}",
  //     endDate: "{{ shop.metafields.freegift.end_date.value }}",
  //     mode: "{{ shop.metafields.freegift.condition_mode.value | default: 'order' }}"
  //   };
  // </script>
  function getFreeGiftConfig() {
    if (window.freeGiftConfig && window.freeGiftConfig.startDate) {
      return window.freeGiftConfig;
    }
    return null;
  }

  // ===================================
  // 🎁 무료증정 자동 add/remove
  // V3.15: 주문 시점(현재 시각) 기준으로 변경
  //        조건: 지금 시각이 이벤트 기간 내 + 카트 합계 $99.99 이상
  // ===================================

  function manageFreeGift(analysis) {
    // V3.18: SKU/Variant ID 미설정 시 무료증정 기능 비활성 (오인 감지 → 무한 reload 방지)
    if (!FREE_GIFT_ENABLED) {
      console.log('🎁 무료증정 SKU/Variant ID 미설정 → 기능 비활성');
      return Promise.resolve(false);
    }

    var config = getFreeGiftConfig();

    // 메타필드 미설정 시 무료증정 비활성 (이벤트 없는 주)
    if (!config || !config.startDate || !config.endDate) {
      console.log('🎁 무료증정 메타필드 미설정 → 이벤트 없는 주');
      if (analysis.freeGiftDetected) {
        console.log('🎁 메타필드 없음 → 무료증정 제거');
        showNotification('Free gift event has ended.', 'warning');
        return addOrRemoveFreeGift(false, analysis.freeGiftDetected);
      }
      return Promise.resolve(false);
    }

    var startDate = new Date(config.startDate + 'T00:00:00');
    var endDate = new Date(config.endDate + 'T23:59:59');

    // V3.16: 조건 기준 토글 — 'order'(주문 시점) / 'delivery'(배송일), 기본값 'order'
    var mode = (config.mode === 'delivery') ? 'delivery' : 'order';
    console.log('🎁 무료증정 기간:', config.startDate, '~', config.endDate, '| 기준:', mode);

    // order 모드: 현재 시각이 이벤트 기간 밖이면 비활성 (배송일 무관)
    if (mode === 'order') {
      var now = new Date();
      var inEventPeriod = now >= startDate && now <= endDate;
      if (!inEventPeriod) {
        console.log('🎁 이벤트 기간 아님 (주문 시점 기준)');
        if (analysis.freeGiftDetected) {
          showNotification('Free gift event has ended.', 'warning');
          return addOrRemoveFreeGift(false, analysis.freeGiftDetected);
        }
        return Promise.resolve(false);
      }
    }

    // 카트 합계 확인 (무료증정 $0 아이템 제외한 실제 합계)
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartTotal = 0;
        cart.items.forEach(function(item) {
          if (String(item.variant_id) !== FREE_GIFT_VARIANT_ID) {
            cartTotal += item.final_line_price / 100;
          }
        });

        var meetsMinimum = cartTotal >= FREE_GIFT_MIN_CART_TOTAL;
        console.log('🎁 실제 카트 합계: $' + cartTotal.toFixed(2) + ' | $' + FREE_GIFT_MIN_CART_TOTAL + ' 이상:', meetsMinimum);

        var isEligible = meetsMinimum;

        // delivery 모드: 캘린더에 기간 내 선택 가능한 배송일이 있어야 증정 (V3.14 방식)
        if (mode === 'delivery') {
          var dateOptions = document.querySelectorAll('.date-option');

          // V3.17: 캘린더가 없는 페이지(드로어, 상품 페이지 등)에서는 판단 보류
          // (캘린더 미로드 상태에서 잘못 제거하는 것 방지)
          if (dateOptions.length === 0) {
            console.log('🎁 캘린더 없는 페이지 → delivery 모드 판단 보류');
            return false;
          }

          var availableDatesInRange = 0;
          dateOptions.forEach(function(opt) {
            var dateStr = opt.dataset.date;
            if (!dateStr) return;
            var parts = dateStr.split('-');
            var optDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
            if (optDate >= startDate && optDate <= endDate) availableDatesInRange++;
          });
          var hasValidDates = availableDatesInRange > 0;
          console.log('🎁 범위 내 배송 가능 날짜:', availableDatesInRange);
          isEligible = meetsMinimum && hasValidDates;
        }

        return addOrRemoveFreeGift(isEligible, analysis.freeGiftDetected);
      });
  }

  // ===================================
  // 🔄 카트 섹션 AJAX 업데이트 (reload 대신)
  // ===================================

  var CART_SECTION_IDS = [
    'template--22152486060257__cart-items',
    'template--22152486060257__cart-footer'
  ];

  function refreshCartSections() {
    // V3.18: 무한 새로고침 방지 가드
    if (!canReloadSafely()) {
      isProcessing = false;
      isFreeGiftProcessing = false;
      return Promise.resolve();
    }
    // 처리 플래그 유지 (reload 전까지 추가 트리거 완전 차단)
    isProcessing = true;
    isFreeGiftProcessing = true;
    var cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      cartItems.style.opacity = '0.4';
      cartItems.style.pointerEvents = 'none';
      cartItems.style.transition = 'opacity 0.15s ease';
    }
    window.location.reload();
    return Promise.resolve();
  }

  function addOrRemoveFreeGift(shouldHave, hasGift) {
    // 중복 실행 방지
    if (isFreeGiftProcessing) {
      console.log('🎁 무료증정 처리 중 → 스킵');
      return Promise.resolve(false);
    }

    // 상태가 동일하면 실행 안 함
    var stateKey = (shouldHave ? '1' : '0') + '-' + (hasGift ? '1' : '0');
    if (lastFreeGiftState === stateKey && !(shouldHave && !hasGift) && !(!shouldHave && hasGift)) {
      console.log('🎁 무료증정 상태 동일 → 스킵');
      return Promise.resolve(false);
    }
    lastFreeGiftState = stateKey;

    if (shouldHave && !hasGift) {
      console.log('🎁 무료증정 자동 추가!');
      isFreeGiftProcessing = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(FREE_GIFT_VARIANT_ID),
            quantity: 1,
            properties: { _free_gift: 'true' }
          }]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        showNotification('Free gift added to your cart!', 'info');
        return refreshCartSections().then(function() { return true; });
      })
      .catch(function(err) {
        console.error('🎁 무료증정 추가 실패:', err);
        return false;
      });

    } else if (!shouldHave && hasGift) {
      console.log('🎁 조건 미충족 → 무료증정 제거');
      isFreeGiftProcessing = true;
      var removeUpdate = {};
      removeUpdate[FREE_GIFT_VARIANT_ID] = 0;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: removeUpdate })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        // V3.15: 날짜 하드코딩 제거, 금액 기준으로 안내
        showNotification('Free gift removed. Orders of $' + FREE_GIFT_MIN_CART_TOTAL + '+ qualify during the event.', 'warning');
        return refreshCartSections().then(function() { return true; });
      });

    } else {
      console.log('🎁 무료증정 상태 유지 (shouldHave:' + shouldHave + ' hasGift:' + hasGift + ')');
      return Promise.resolve(false);
    }
  }

  // ===================================
  // 🔧 일반 규칙 적용
  // ===================================

  function applyNormalRules(analysis, previousHasDeal) {
    var updates = {};
    var needsUpdate = false;
    var quantityAdjusted = false;

    // 규칙 1: weekly-deal 수량 1개 초과 → 1개로 강제 (무료증정 제외한 deal 아이템만)
    var nonGiftDealItems = analysis.dealItems.filter(function(item) {
      return !isFreeGiftMatch(item.id, item.sku); // V3.18: 빈 값 매칭 차단
    });

    var nonGiftTotalQty = nonGiftDealItems.reduce(function(sum, item) {
      return sum + item.quantity;
    }, 0);

    if (nonGiftTotalQty > MAX_DEAL_QUANTITY) {
      nonGiftDealItems.forEach(function(item, index) {
        if (index === 0) {
          updates[item.id] = MAX_DEAL_QUANTITY;
        } else {
          updates[item.id] = 0;
        }
        needsUpdate = true;
        quantityAdjusted = true;
      });
      console.log('🚨 weekly-deal 수량 ' + nonGiftTotalQty + ' → 1개로 강제');
    }

    // 규칙 2: 무료증정 아이템 수량 1개 초과 → 1개로 강제
    if (analysis.freeGiftDetected && analysis.freeGiftQuantity > MAX_DEAL_QUANTITY) {
      updates[analysis.freeGiftVariantId] = MAX_DEAL_QUANTITY;
      needsUpdate = true;
      quantityAdjusted = true;
      console.log('🚨 무료증정 수량 ' + analysis.freeGiftQuantity + ' → 1개로 강제');
    }

    if (needsUpdate) {
      return updateCart(updates).then(function() {
        var translations = window.weeklyDealTranslations || {};
        if (quantityAdjusted) {
          var message = translations.quantity_limit || 'Limited to 1 per order';
          showNotification(message, 'info');
        }
      });
    }

    // 캘린더 필터: deal 상태가 변경될 때만
    if (hasDealInCart && !previousHasDeal) {
      console.log('📅 특가 추가됨 → 캘린더 필터 적용');
      setTimeout(applyWeeklyDealCalendarFilter, 200);
    } else if (!hasDealInCart && previousHasDeal) {
      console.log('📅 특가 제거됨 → 캘린더 복원');
      restoreNormalCalendar();
    }

    // $120 or $99.99 미만 체크아웃 차단
    if (hasDealInCart && analysis.cartTotal < MIN_CART_TOTAL) {
      blockCheckout(analysis.cartTotal);
    } else {
      unblockCheckout();
    }

    // CSS 클래스 수량 잠금 재적용 (weekly-deal + 무료증정 모두)
    if (hasDealInCart || hasFreeGiftInCart) {
      disableQuantityButtons(analysis.freeGiftVariantId);
    }

    // V3.17: 무료증정 가격 FREE 표시 (자동 할인은 체크아웃에서 적용, 카트는 표시 보강)
    if (hasFreeGiftInCart) {
      styleFreeGiftPriceDisplay();
    }

    console.log('✅ 규칙 통과 (최소주문금액: $' + MIN_CART_TOTAL + ')');
    return Promise.resolve();
  }

  // ===================================
  // 🎁 V3.17: 카트에서 무료증정 가격을 FREE로 표시
  // 실제 $0 처리는 Shopify 자동 할인이 체크아웃에서 수행
  // ===================================

  function styleFreeGiftPriceDisplay() {
    var rows = document.querySelectorAll('tr.cart-item');

    rows.forEach(function(row) {
      var qtyInput = row.querySelector('.quantity__input');
      var rowVariantId = qtyInput ? qtyInput.getAttribute('data-quantity-variant-id') : '';
      var sku = row.getAttribute('data-sku') || row.getAttribute('data-variant-sku') || '';
      var isFreeGift = isFreeGiftMatch(rowVariantId, sku); // V3.18: 빈 값 매칭 차단

      if (!isFreeGift) return;
      if (row.querySelector('.free-gift-price-label')) return; // 중복 방지

      var priceEls = row.querySelectorAll('price-money bdi');
      priceEls.forEach(function(el) {
        var original = el.textContent;
        var numeric = parseFloat(original.replace(/[^0-9.]/g, '')) || 0;

        if (numeric === 0) {
          // 상품 가격이 $0이면 그냥 FREE로 표시
          el.innerHTML =
            '<span class="free-gift-price-label" style="color:#FF4713;font-weight:700;">FREE</span>';
        } else {
          // 가격이 있으면 취소선 + FREE (자동 할인 방식일 때)
          el.innerHTML =
            '<s style="opacity:0.5;">' + original + '</s> ' +
            '<span class="free-gift-price-label" style="color:#FF4713;font-weight:700;">FREE</span>';
        }
      });
    });
  }

  // ===================================
  // 🚫 체크아웃 차단/해제
  // ===================================

  function blockCheckout(cartTotal) {
    var checkoutBtn = document.querySelector('button[name="checkout"]') ||
                      document.getElementById('checkout') ||
                      document.querySelector('[name="checkout"]') ||
                      document.querySelector('.cart__checkout-button');

    if (!checkoutBtn) return;

    checkoutBtn.disabled = true;
    checkoutBtn.style.opacity = '0.5';
    checkoutBtn.style.cursor = 'not-allowed';
    checkoutBtn.style.pointerEvents = 'none';

    var existingMsg = document.getElementById('weekly-deal-checkout-msg');
    var remaining = (MIN_CART_TOTAL - cartTotal).toFixed(2);
    var translations = window.weeklyDealTranslations || {};
    var message = translations.checkout_blocked ||
      'Add $' + remaining + ' more to use the weekly special (min. $' + MIN_CART_TOTAL + ')';

    if (!existingMsg) {
      var msg = document.createElement('div');
      msg.id = 'weekly-deal-checkout-msg';
      msg.style.cssText =
        'color:#FF4713;font-size:13px;font-weight:500;' +
        'text-align:center;padding:8px 12px;margin-top:8px;' +
        'background:#FFF5F2;border-radius:6px;';
      msg.innerHTML = message;
      checkoutBtn.parentNode.insertBefore(msg, checkoutBtn.nextSibling);
    } else {
      existingMsg.innerHTML = message;
    }

    console.log('🚫 체크아웃 차단 - Cart: $' + cartTotal.toFixed(2) + ' < $' + MIN_CART_TOTAL);
  }

  function unblockCheckout() {
    var checkoutBtn = document.querySelector('button[name="checkout"]') ||
                      document.getElementById('checkout') ||
                      document.querySelector('[name="checkout"]') ||
                      document.querySelector('.cart__checkout-button');

    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.cursor = '';
      checkoutBtn.style.pointerEvents = '';
    }

    var existingMsg = document.getElementById('weekly-deal-checkout-msg');
    if (existingMsg) existingMsg.remove();
  }

  // ===================================
  // 🔄 메인 체크 함수
  // ===================================

  function enforceWeeklyDealRules() {
    if (isProcessing) return Promise.resolve();
    isProcessing = true;

    var hasDataTags = document.querySelector('tr.cart-item[data-tags]');
    var analyzePromise;

    if (hasDataTags) {
      console.log('⚡ DOM 기반 즉시 분석');
      analyzePromise = Promise.resolve(analyzeCartFromDOM());
    } else {
      console.log('🌐 API fallback 분석');
      analyzePromise = analyzeCartFromAPI();
    }

    return analyzePromise
      .then(function(analysis) {
        return enforceRules(analysis);
      })
      .then(function() {
        isProcessing = false;
      })
      .catch(function(error) {
        console.error('❌ Error:', error);
        isProcessing = false;
      });
  }

  // ===================================
  // 🔒 수량 버튼 비활성화 (CSS 클래스만)
  // weekly-deal 태그 아이템 + 무료증정 아이템 모두 잠금
  // ===================================

  function disableQuantityButtons(freeGiftVariantId) {
    var rows = document.querySelectorAll('tr.cart-item[data-tags]');

    rows.forEach(function(row) {
      var tags = (row.getAttribute('data-tags') || '').split(',');
      var hasDealTag = tags.some(function(tag) {
        return tag.trim() === DEAL_TAG;
      });

      // 무료증정 아이템도 잠금: Variant ID 우선, SKU fallback
      var sku = row.getAttribute('data-sku') || row.getAttribute('data-variant-sku') || '';
      var qtyInput = row.querySelector('.quantity__input');
      var rowVariantId = qtyInput ? qtyInput.getAttribute('data-quantity-variant-id') : '';
      var isFreeGift = isFreeGiftMatch(rowVariantId, sku); // V3.18: 빈 값 매칭 차단

      if (hasDealTag || isFreeGift) {
        row.classList.add('weekly-deal-locked');
      } else {
        row.classList.remove('weekly-deal-locked');
      }
    });
  }

  // ===================================
  // 🛒 Cart Drawer 안내 메시지
  // ===================================

  function addDrawerNotices() {
    var drawerItems = document.querySelectorAll('.mini-cart__navigation li[data-tags]');
    if (!drawerItems.length) return;

    drawerItems.forEach(function(li) {
      var tags = (li.getAttribute('data-tags') || '').split(',');
      var hasDeal = tags.some(function(tag) {
        return tag.trim() === DEAL_TAG;
      });

      if (!hasDeal) return;
      if (li.querySelector('.weekly-deal-drawer-notice')) return;

      var notice = document.createElement('div');
      notice.className = 'weekly-deal-drawer-notice';
      notice.style.cssText =
        'font-size:11px;color:#FF4713;padding:6px 8px;margin-top:4px;' +
        'font-weight:500;background:#FFF5F2;border-radius:4px;line-height:1.6;';

      var translations = window.weeklyDealTranslations || {};

      // 무료증정 아이템일 때와 일반 weekly-deal일 때 메시지 분기
      var sku = li.getAttribute('data-sku') || li.getAttribute('data-variant-sku') || '';
      var liVariantId = li.getAttribute('data-variant-id') || '';
      var isFreeGift = isFreeGiftMatch(liVariantId, sku); // V3.18: 빈 값 매칭 차단

      var line1, line2;
      if (isFreeGift) {
        line1 = translations.free_gift_limit || 'Free gift: Limited to 1 per order';
        line2 = translations.free_gift_minimum || 'Requires $' + FREE_GIFT_MIN_CART_TOTAL + '+ purchase';
      } else {
        line1 = translations.quantity_limit || 'Limited to 1 per order';
        line2 = translations.under_minimum || 'Requires $' + DEFAULT_MIN_CART_TOTAL + '+ in regular items';
      }

      notice.innerHTML = line1 + ' &middot; ' + line2;

      var container = li.querySelector('.product-container');
      if (container) {
        container.after(notice);
        console.log('📌 Drawer 안내 추가');
      }
    });
  }

  // ===================================
  // 🛒 카트 업데이트
  // ===================================

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      var cartItems = document.getElementById('main-cart-items');
      if (cartItems) {
        cartItems.style.opacity = '0.4';
        cartItems.style.pointerEvents = 'none';
        cartItems.style.transition = 'opacity 0.15s ease';
      }
      if (canReloadSafely()) window.location.reload(); // V3.18: reload 가드
    });
  }

  // ===================================
  // 💬 알림 메시지
  // ===================================

  function showNotification(message, type) {
    type = type || 'info';

    // 기존 알림 제거
    var existing = document.querySelector('.weekly-deal-notification');
    if (existing) existing.remove();

    var notification = document.createElement('div');
    notification.className = 'weekly-deal-notification weekly-deal-notification--' + type;

    var icon = document.createElement('div');
    icon.className = 'weekly-deal-notification__icon';
    icon.textContent = type === 'info' ? '🎁' : '🛒';

    var messageEl = document.createElement('div');
    messageEl.className = 'weekly-deal-notification__message';
    messageEl.textContent = message;

    var closeBtn = document.createElement('button');
    closeBtn.className = 'weekly-deal-notification__close';
    closeBtn.innerHTML = '&times;';
    closeBtn.onclick = function() {
      notification.classList.remove('show');
      setTimeout(function() { notification.remove(); }, 400);
    };

    notification.appendChild(icon);
    notification.appendChild(messageEl);
    notification.appendChild(closeBtn);
    document.body.appendChild(notification);

    setTimeout(function() { notification.classList.add('show'); }, 50);

    setTimeout(function() {
      notification.classList.remove('show');
      setTimeout(function() { notification.remove(); }, 400);
    }, 4000);
  }

  // ===================================
  // 👂 이벤트 리스너
  // ===================================

  function setupListeners() {
    ['click', 'touchend'].forEach(function(eventType) {
      document.addEventListener(eventType, function(e) {
        var target = e.target;

        var lockedRow = target.closest('.weekly-deal-locked');
        if (lockedRow) {
          var isQtyBtn = target.closest('.quantity__button') ||
                        target.closest('button[name="plus"]') ||
                        target.closest('button[name="minus"]');
          if (isQtyBtn) return;
        }

        var isQuantityButton = target.closest('.quantity__button') ||
                              target.closest('button[name="plus"]') ||
                              target.closest('button[name="minus"]');

        var isRemoveButton = target.closest('cart-remove-button') ||
                            target.closest('.cart-item__remove');

        if (isQuantityButton || isRemoveButton) {
          setTimeout(enforceWeeklyDealRules, 500);
        }
      }, { passive: true });
    });

    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('quantity__input')) {
        setTimeout(enforceWeeklyDealRules, 500);
      }
    });

    // 카트 이벤트 감지 (수량 변경, 삭제 등)
    ['cart:updated', 'cart:change', 'cart:refresh'].forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        setTimeout(enforceWeeklyDealRules, 300);
      });
    });

    // Shopify 공식 카트 구독 (상품 추가 감지)
    if (window.Shopify && window.Shopify.on) {
      window.Shopify.on('cart:item-added', function() {
        setTimeout(enforceWeeklyDealRules, 400);
      });
    }

    // MutationObserver로 카트 아이템 DOM 변화 감지 (상품 추가 시)
    var cartItemsEl = document.getElementById('main-cart-items');
    if (cartItemsEl) {
      var cartItemObserver = new MutationObserver(function(mutations) {
        var hasSignificantChange = mutations.some(function(m) {
          return m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0);
        });
        if (hasSignificantChange) {
          setTimeout(enforceWeeklyDealRules, 400);
        }
      });
      cartItemObserver.observe(cartItemsEl, { childList: true, subtree: true });
    }

    document.addEventListener('cartdrawer:opened', function() {
      setTimeout(addDrawerNotices, 300);
    });

    var miniCartEl = document.getElementById('mini-cart');
    if (miniCartEl) {
      var drawerEnforceTimer = null;
      var observer = new MutationObserver(function(mutations) {
        var hasChange = mutations.some(function(m) {
          return m.type === 'childList';
        });
        if (hasChange) {
          setTimeout(addDrawerNotices, 200);
          // V3.17: 드로어에서 상품 추가/변경 시에도 무료증정 규칙 실행 (디바운스)
          clearTimeout(drawerEnforceTimer);
          drawerEnforceTimer = setTimeout(enforceWeeklyDealRules, 500);
        }
      });
      observer.observe(miniCartEl, { childList: true, subtree: true });
    }

    window.addEventListener('calendarRendered', function() {
      if (hasDealInCart) {
        if (!calendarInitialized) {
          calendarInitialized = true;
          setTimeout(applyWeeklyDealCalendarFilter, 150);
        } else {
          setTimeout(filterCalendarDatesOnly, 150);
        }
      }
    });

    window.addEventListener('chefBanchanFulfillmentChanged', function() {
      if (hasDealInCart) {
        calendarInitialized = false;
        setTimeout(applyWeeklyDealCalendarFilter, 300);
      }
    });

  }

  // ===================================
  // 🎨 스타일
  // ===================================

  function injectStyles() {
    var style = document.createElement('style');
    style.textContent =
      '.weekly-deal-locked .quantity__button[name="plus"],' +
      '.weekly-deal-locked .quantity__button[name="minus"],' +
      '.weekly-deal-locked button[name="plus"],' +
      '.weekly-deal-locked button[name="minus"] {' +
        'opacity: 0.3 !important;' +
        'cursor: not-allowed !important;' +
        'pointer-events: none !important;' +
      '}' +
      '.weekly-deal-locked .quantity__input {' +
        'opacity: 0.6 !important;' +
        'cursor: not-allowed !important;' +
        'pointer-events: none !important;' +
      '}' +
      '.weekly-deal-notification {' +
        'position: fixed; bottom: 24px; left: 50%;' +
        'transform: translateX(-50%) translateY(80px);' +
        'padding: 14px 16px;' +
        'border-radius: 14px;' +
        'z-index: 10000; opacity: 0;' +
        'transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);' +
        'font-size: 13px; font-weight: 500;' +
        'width: calc(100% - 32px); max-width: 360px;' +
        'display: flex; align-items: center; gap: 12px;' +
      '}' +
      '.weekly-deal-notification.show {' +
        'opacity: 1; transform: translateX(-50%) translateY(0);' +
      '}' +
      '.weekly-deal-notification--info {' +
        'background: #FF4713;' +
      '}' +
      '.weekly-deal-notification--info .weekly-deal-notification__message { color: #fff; }' +
      '.weekly-deal-notification--info .weekly-deal-notification__close { color: rgba(255,255,255,0.8); }' +
      '.weekly-deal-notification--warning {' +
        'background: white; border: 0.5px solid rgba(0,0,0,0.12);' +
        'box-shadow: 0 4px 20px rgba(0,0,0,0.12);' +
      '}' +
      '.weekly-deal-notification--warning .weekly-deal-notification__message { color: #222; }' +
      '.weekly-deal-notification--warning .weekly-deal-notification__close { color: #999; }' +
      '.weekly-deal-notification__icon {' +
        'width: 32px; height: 32px; border-radius: 50%;' +
        'display: flex; align-items: center; justify-content: center;' +
        'flex-shrink: 0; font-size: 16px;' +
      '}' +
      '.weekly-deal-notification--info .weekly-deal-notification__icon { background: rgba(255,255,255,0.2); }' +
      '.weekly-deal-notification--warning .weekly-deal-notification__icon { background: #f5f5f5; }' +
      '.weekly-deal-notification__message { flex: 1; line-height: 1.4; }' +
      '.weekly-deal-notification__close {' +
        'width: 24px; height: 24px; border: none;' +
        'background: transparent;' +
        'font-size: 18px; line-height: 1; cursor: pointer;' +
        'display: flex; align-items: center; justify-content: center;' +
        'border-radius: 4px; padding: 0; flex-shrink: 0;' +
      '}';

    document.head.appendChild(style);
  }

  // ===================================
  // ⚡ 초기화
  // ===================================

  function initialize() {
    console.log('🚀 Weekly Deal V3.18 Init');

    injectStyles();
    setupListeners();

    if (document.querySelector('tr.cart-item')) {
      setTimeout(function() {
        enforceWeeklyDealRules().then(function() {
          disableQuantityButtons(null);
          if (hasDealInCart) {
            setTimeout(applyWeeklyDealCalendarFilter, 300);
          }
        });
      }, 100);
    }

    setTimeout(addDrawerNotices, 300);

    console.log('✅ V3.18 Ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 100);
  }

  window.weeklyDealManager = {
    check: enforceWeeklyDealRules,
    analyze: function() { return Promise.resolve(analyzeCartFromDOM()); },
    disableButtons: disableQuantityButtons,
    checkDrawer: addDrawerNotices,
    applyCalendarFilter: applyWeeklyDealCalendarFilter,
    getDateRange: getWeeklyDealDateRange,
    hasDeal: function() { return hasDealInCart; },
    hasFreeGift: function() { return hasFreeGiftInCart; },
    getMinTotal: function() { return MIN_CART_TOTAL; }
  };

})();